<template>
  <!--服务-->
  <div class="serviceBox" :style="{marginTop:mt}" v-if="screenType === 'pc'">
    <el-row>
      <el-col :span="4"></el-col>
      <el-col :span="16">
        <div class="serviceContentBox">
          <el-row style="width: 100%;" justify="space-between">
            <el-col :span="6" v-for="(item,index) in serviceData.data" :key="item">
              <div class="serviceInfoBox">
                <div class="serviceTitle SourceHanSansCN-Medium" :class="['serviceTitle'+index]"
                     @click="handleParentGoto(item.link,item.title)">{{
                    item.title
                  }}
                </div>

                <div class="serviceChildTitleBox">
                  <el-row style="width: 100%">
                    <el-col :span="24">
                      <div :class="['serviceSubtitleBox','serviceSubtitleBox'+cIndex]"
                           v-for="(cItem,cIndex) in item.list"
                           :key="cItem">
                        <div class="serviceSubtitle SourceHanSansCN-Light"
                             @click="handleGoTo(cItem.link,cItem.type,cItem.title)">{{
                            cItem.title
                          }}

                          <template v-if="cItem.title === '贷款预约' && visiable">
                            <loanReservation ref="loanReservationRef" @click.stop="handleCloseMask"></loanReservation>
                          </template>

                        </div>
                      </div>
                      <div class="serviceBorder" v-if="index !== (serviceData.data.length - 1)"></div>
                    </el-col>

                  </el-row>

                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="4"></el-col>
    </el-row>

  </div>

  <div class="serviceBox-mobile" v-else>
    <div class="sMobileBox" v-for="item in serviceData.data" :key="item">
      <div class="sMobileBoxTitle">{{ item.title }}</div>
      <div class="sMobileChildBox">
        <div class="sMobileChildTitle" v-for="(cItem,cIndex) in item.list"
             :key="cItem" @click="handleGoTo(cItem.link,cItem.type,cItem.title)">{{ cItem.title }}
        </div>
      </div>
    </div>
    <loanReservation ref="loanReservationRef" @click.stop="handleCloseMask"></loanReservation>
    <!-- 贷款预约  -->
    <!--<div class="sMobilePop fadeIn" v-if="sMobileFlag">-->
    <!--  <div class="sMobilePopContent">-->
    <!--    <div class="sMobileMenu">-->
    <!--      <div class="sMobileCancle" @click="handleCancle">取消</div>-->
    <!--    </div>-->
    <!--    <div class="sMobilePopContentTitle" :class="['sMobilePopContentTitle' + index]" v-for="(item,index) in linkData"-->
    <!--         :key="item" @click="handleJumpTo(item)">{{ item.name }}-->
    <!--    </div>-->
    <!--  </div>-->
    <!--</div>-->
  </div>


</template>

<script setup>
import {defineEmits, defineProps, onMounted, reactive, ref} from "vue";
import router from "@/router";
import {AdaptationScreen, fileUrl, loanAppointmentJumpConnection} from "@/common/js/config.default";

import {clickMonitor} from "@/common/js/tools"
import {eventBus} from "@/store/eventBus";
import {informationInfo} from "@/http/publicityInformation/servicePricePublicity"

const props = defineProps({
  mt: {
    type: String,
    default: '100px'
  }
})

const visiable = ref(false)

const emit = defineEmits(['hanelFinancialMeasurement', 'handleScrollToBottom'])

const screenType = ref('pc');

const serviceData = reactive({
  data: [
    {
      title: '最新活动',
      link: '/latestActivity/activity1',
      list: [
        {
          title: '最新活动',
          link: '/latestActivity/activity1'
        },
      ]
    },
    {
      title: '金融服务',
      link: "",
      list: [
        {
          title: '金融测算',
          link: "/"
        },
        {
          title: '金融产品',
          link: "/financialServices/financialProducts"
        },
        {
          title: '车贷指南',
          link: "/financialServices/carLoanGuidelines"
        },
        {
          title: '贷款预约',
          link: "",
          type: "hash",
          data: []
        },
        {
          title: '大客户服务',
          link: "/bigHome"
        },
      ]
    },
    {
      title: '公示信息',
      link: "/publicityInformation/pInformation",
      list: [
        {
          title: '信息披露',
          link: "/publicityInformation/informationDisclosure"
        },
        {
          title: '服务价格公示',
          link: "/publicityInformation/servicePricePublicity"
        },
        {
          title: '金融许可证公告',
          link: "",
          type: "open"
        },
        {
          title: '营业执照',
          type: "open",
          link: ""
        },
        {
          title: '金融知识宣传',
          link: "/latestActivity/activity1"
        },
        {
          title: '汽车金融业务合同模版',
          link: "/publicityInformation/contractTemplate"
        },
        {
          title: '投诉及征信异议受理渠道及流程',
          link: '/publicityInformation/complaintAcceptance'
        },
      ]
    },
    {
      title: '关于我们',
      link: "",
      list: [
        {
          title: '公司介绍',
          link: "/aboutUs/publicityIntroduction"
        },
        {
          title: '门店查询',
          link: "/aboutUs/dealerQuery"
        },
        {
          title: '联系我们',
          link: ""
        },
        {
          title: '客户留言',
          link: "/aboutUs/customerMessage"
        },
        {
          title: '隐私政策',
          link: "https://afc.oss-cn-shanghai.aliyuncs.com/AFC/publicityinformation/privacy.pdf?v=" + Math.random() * 100,
          type: "open"
        },
      ]
    }
  ]
})

const sMobileFlag = ref(false);

const handleParentGoto = (link, title) => {
  if (link) {
    router.push({
      path: link
    })
  }
}
const loanReservationRef = ref(null)
const handleGoTo = (e, type, title) => {
  if (e) {
    if (type === "open") {
      window.open(e)
    } else {
      if (title === '金融测算') {
        emit('hanelFinancialMeasurement', true)
        router.push({
          path: e,
          query: {
            hanelFinancialMeasurement: true
          }
        })
      } else if (title === '金融知识宣传') {

        eventBus.emit('activeIndex', 4);

        router.push({
          path: e,
          query: {
            activeIndex: 4
          }
        })
      } else {
        router.push(e)
      }
    }
  } else {
    if (title === '联系我们') {
      emit('handleScrollToBottom', true)
    } else if (title === '贷款预约') {
      if (screenType.value === 'pc') {
        visiable.value = !visiable.value;
      } else {
        //sMobileFlag.value = true;
        loanReservationRef.value.handleOpenMask();

      }

    }
  }

  clickMonitor({
    event_en: "底部—" + title,
    event_cn: "底部—" + title,
  })

}

const handleCloseMask = () => {
  visiable.value = false;
}

const linkData = ref(loanAppointmentJumpConnection)

const handleJumpTo = (item) => {
  if (item.link) {
    window.open(item.link)
  }
}

const handleCancle = () => {
  sMobileFlag.value = false;
}

//金融许可公告
const publicityInformation = () => {
  informationInfo({
    moduleType: 'jrxkzgg'
  }).then(res => {
    if (res.code === 200) {
      let findIndex = serviceData.data.findIndex(item => item.title === '公示信息')
      let findChildIndex = serviceData.data[findIndex].list.findIndex(item => item.title === '金融许可证公告')
      serviceData.data[findIndex].list[findChildIndex].link = fileUrl + res.data[0].fileUrl
    }
  })
  //
  informationInfo({
    moduleType: 'yyzz'
  }).then(res => {
    if (res.code === 200) {
      let findIndex = serviceData.data.findIndex(item => item.title === '公示信息')
      let findChildIndex = serviceData.data[findIndex].list.findIndex(item => item.title === '营业执照')
      serviceData.data[findIndex].list[findChildIndex].link = fileUrl + res.data[0].fileUrl
    }
  })
}

onMounted(() => {
  AdaptationScreen(() => {
    screenType.value = 'mobile'
  }, () => {
    screenType.value = 'pc'
  })

  publicityInformation();
})

</script>

<style scoped lang="scss">
@import "@/common/scss/breakpoints";

.serviceBox {
  width: 100%;
  height: auto;
  position: relative;
  background: #FCFCFC;
  //margin-top: 100px;
  padding-bottom: 85px;

  .serviceContentBox {
    //width: 1200px;
    //position: absolute;
    //top: 142px;
    //left: 50%;
    //transform: translateX(-50%);
    width: 100%;
    margin: 142px auto 0;
    display: flex;

    .serviceInfoBox {
      //width: 255px;
      height: auto;
      font-size: 25px;
      color: #18549C;
      position: relative;
      //margin-right: 142px;
      //cursor: pointer;

      &:last-child {
        margin-right: 0;
      }

      .serviceTitle {
        width: 100%;
        height: auto;
        //padding-left: 96px;
        box-sizing: border-box;
        text-align: center;
      }

      .serviceTitle0, .serviceTitle2 {
        cursor: pointer;
      }

      .serviceChildTitleBox {
        width: 100%;
        height: auto;
        position: relative;
      }
    }

    .serviceSubtitleBox {
      width: 100%;
      height: auto;

      &.serviceSubtitleBox0 {
        margin-top: 58px;
      }

      .serviceSubtitle {
        width: 100%;
        font-size: 20px;
        color: #797979;
        margin-bottom: 38px;
        cursor: pointer;
        //padding-left: 96px;
        box-sizing: border-box;
        position: relative;
        text-align: center;


      }
    }

    .serviceBorder {
      width: 1px;
      height: 390px;
      background: #707070;
      margin-top: 58px;
      position: absolute;
      top: 0px;
      right: 0px;
    }
  }

}

@include media-breakpoint-up("md") {
  @import "./index-md.scss";
}

</style>
